(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return cents;
  }

  function renderPrice(item, variant) {
    var priceEl = item.querySelector('[data-cross-sell-price]');
    if (!priceEl) return;

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var html = '<span class="cross-sell-item__price-sale' + (onSale ? '' : ' cross-sell-item__price-sale--no-compare') + '">' +
      formatMoney(variant.price) +
      '</span>';
    if (onSale) {
      html += '<span class="cross-sell-item__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
    }
    priceEl.innerHTML = html;
  }

  function updateAddButton(item, variant) {
    var button = item.querySelector('[data-cross-sell-add]');
    if (!button) return;

    button.setAttribute('data-variant-id', variant.id);
    button.disabled = !variant.available;

    var label = button.querySelector('[data-cross-sell-add-label]');
    if (label) {
      label.textContent = variant.available
        ? (window.variantStrings && window.variantStrings.addToCart ? '+ ' + window.variantStrings.addToCart : '+ Add')
        : 'Sold out';
    }
  }

  function getVariants(item) {
    var script = item.querySelector('[data-cross-sell-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function updateVariantImage(item, select) {
    var image = item.querySelector('.cross-sell-item__image img');
    if (!image) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var imageUrl = option.getAttribute('data-variant-image');

    // If this variant has no image, keep the current product image.
    if (!imageUrl) return;

    image.style.opacity = '0.35';

    var preloader = new Image();

    preloader.onload = function () {
      image.src = imageUrl;

      window.setTimeout(function () {
        image.style.opacity = '';
      }, 120);
    };

    preloader.onerror = function () {
      image.style.opacity = '';
    };

    preloader.src = imageUrl;
  }

  function onVariantChange(event) {
    var select = event.target;
    var item = select.closest('[data-cross-sell-item]');
    if (!item) return;

    var variants = getVariants(item);
    var variant = variants.filter(function (v) {
      return String(v.id) === select.value;
    })[0];
    if (!variant) return;

    renderPrice(item, variant);
    updateAddButton(item, variant);
    updateVariantImage(item, select);
  }

  function refreshCart() {
    if (typeof Shopify === 'undefined' || typeof Shopify.getCart !== 'function') return;

    Shopify.getCart(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });

      var afterAddToCart = window.after_add_to_cart || { type: 'quick_cart' };
      var quickCart = window.quick_cart || { show: false };

      if (afterAddToCart.type === 'cart') {
        window.location.href = window.routes ? window.routes.cart : '/cart';
        return;
      }

      if (quickCart.show && typeof window.halo !== 'undefined' && typeof window.halo.updateSidebarCart === 'function') {
        window.halo.updateSidebarCart(cart);
        document.body.classList.add('cart-sidebar-show');
      }

      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
    });
  }

  function onAddClick(event) {
    var button = event.currentTarget;
    if (button.disabled || button.classList.contains('is-loading')) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.classList.add('is-loading');

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          var message = (data.description || (window.cartStrings && window.cartStrings.error) || 'Could not add this item to your cart.');
          window.alert(message);
          return;
        }
        refreshCart();
      })
      .catch(function (error) {
        console.error('cross-sell add to cart error:', error);
      })
      .finally(function () {
        button.classList.remove('is-loading');
      });
  }

  function setUpPagination(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-cross-sell-item]'));
    var pageSize = parseInt(list.getAttribute('data-page-size'), 10) || items.length;
    if (items.length <= pageSize) return;

    var wrapper = list.closest('.cross-sell');
    var nav = wrapper ? wrapper.querySelector('[data-cross-sell-nav]') : null;
    var prevButton = wrapper ? wrapper.querySelector('[data-cross-sell-prev]') : null;
    var nextButton = wrapper ? wrapper.querySelector('[data-cross-sell-next]') : null;
    if (!nav || !prevButton || !nextButton) return;

    nav.hidden = false;
    var page = 0;
    var pageCount = Math.ceil(items.length / pageSize);

    function render() {
      items.forEach(function (item, index) {
        var onPage = Math.floor(index / pageSize) === page;
        item.toggleAttribute('data-cross-sell-hidden', !onPage);
      });
      prevButton.disabled = page === 0;
      nextButton.disabled = page === pageCount - 1;
    }

    prevButton.addEventListener('click', function () {
      if (page === 0) return;
      page -= 1;
      render();
    });

    nextButton.addEventListener('click', function () {
      if (page === pageCount - 1) return;
      page += 1;
      render();
    });

    render();
  }

  document.querySelectorAll('.cross-sell__list').forEach(setUpPagination);

  document.querySelectorAll('[data-cross-sell-variant-select]').forEach(function (select) {
    select.addEventListener('change', onVariantChange);
  });

  document.querySelectorAll('[data-cross-sell-add]').forEach(function (button) {
    button.addEventListener('click', onAddClick);
  });
})();
